import URLService from "infra/envs/URL.service";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CvIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconBtn from "components/lib-ui/IconBtn";
import Link from "@mui/material/Link";
import LinqIcon from "assets/icons/LinqIcon";
import MatchedKeywordsCell from "./MatchedKeywordsCell";

const linkedinPrefix = "https://www.linkedin.com/in/";

export const tableColumnHeaders = [
    {
        field: "id",
        headerName: "ID",
        width: 80,
    },
    // TODO: Will be enabled once the elligibility functionality is live
    // {
    //     field: "elligible",
    //     headerName: "Elligible",
    //     width: 80,
    //     renderCell: (params) => (
    //         <div>
    //             {params.value === "Yes" ? (
    //                 <CheckCircleOutlinedIcon color="success" fontSize="small" />
    //             ) : (
    //                 <CancelOutlinedIcon color="error" fontSize="small" />
    //             )}
    //         </div>
    //     ),
    // },
    {
        field: "last_name",
        headerName: "Last name",
        sortable: false,
        width: 160,
    },
    {
        field: "first_name",
        headerName: "First name",
        sortable: false,
        width: 160,
    },
    {
        field: "email",
        headerName: "Email",
        sortable: false,
        width: 250,
        flex: 1,
    },
    {
        field: "phone_number",
        headerName: "Phone",
        description: "This column has a value getter and is not sortable.",
        sortable: false,
        flex: 1,
    },
    {
        field: "matchedKeywords",
        headerName: "Matched keywords",
        sortable: false,
        flex: 1,
        renderCell: (params) => (
            <MatchedKeywordsCell matchedKeywords={params.value} />
        ),
    },
    {
        field: "linkedin_profile",
        headerName: "LI",
        width: 5,
        renderCell: (params) => (
            <div>
                {params.value ? (
                    <Link
                        href={`${linkedinPrefix}${params.value}`}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <IconBtn icon={LinkedInIcon} />
                    </Link>
                ) : (
                    <IconBtn
                        disabled={true}
                        sx={{ opacity: 0.3 }}
                        icon={LinkedInIcon}
                    />
                )}
            </div>
        ),
    },
    {
        field: "collegelink_profile_id",
        headerName: "linq",
        width: 5,
        renderCell: (params) => (
            <div>
                {params.value !== null ? (
                    <Link
                        href={`${params.value}`}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <IconBtn icon={LinqIcon} />
                    </Link>
                ) : (
                    <IconBtn
                        disabled={true}
                        sx={{ opacity: 0.3 }}
                        icon={LinqIcon}
                    />
                )}
            </div>
        ),
    },
    {
        field: "cv",
        headerName: "CV",
        width: 5,
        renderCell: (params) => {
            return (
                <div>
                    {params.value.length ? (
                        <IconBtn
                            onClick={() => window.open(params.value)}
                            icon={CvIcon}
                        />
                    ) : (
                        <IconBtn
                            disabled={true}
                            sx={{ opacity: 0.3 }}
                            icon={CvIcon}
                        />
                    )}
                </div>
            );
        },
    },
    {
        field: "view",
        headerName: "View",
        description: "View the candidate's full",
        sortable: false,
        width: 55,
        renderCell: (params) => (
            <div>
                <Link
                    href={`${URLService.CANDIDATE_PROFILE_PATH}/${params.value}`}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <IconBtn icon={VisibilityIcon} />
                </Link>
            </div>
        ),
    },
];

export default tableColumnHeaders;
